import { CascaderOptionType } from 'antd/lib/cascader'
import { Country, HrSupportFeedbackTabFilter } from '../../../types'

export enum HrSupportTabs {
  feedback = 'feedback',
  hrbusinessPartner = 'hrbusinessPartner',
  countrySettings = 'countrySettings',
  nationalContractReference = 'nationalContractReference',
}

export interface HrSupportState {
  storeInitialized: boolean
  activeTab: string
  selectableCountries: CascaderOptionType[]
  selected: CascaderOptionType
  feedbackTabFilters: HrSupportFeedbackTabFilter

  initStore: (selectableCountries: Country[]) => void
  setActiveTab: (activeTab: string) => void
  setSelected: (country: Country) => void
  setFeedbackTabFilters: (filters: HrSupportFeedbackTabFilter) => void
}
